export default {
  title: 'Formation Développeur Web et Mobile',
  description: 'Formez-vous à la programmation Web et Mobile auprès d’une équipe de passionnés.',
  keywords:
    'formation web, formation mobile, formation développeur, formation développeur web, formation développeur mobile, formation développeur mobile, coding bootcamp, formation React Native, JavaScript, formation React, formation ReactJS, formation Redux',
  image: 'https://www.lereacteur.io/images/og-image.jpg',
};
